import theme from '@styles/theme';
const positionVariant = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
export default {
  iconBox: (position: 'left' | 'center' | 'right') => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: positionVariant[position],
    rowGap: 16,
    h5: {
      textAlign: position,
      maxWidth: 237,
      width: '100%',
      display: 'block'
    }
  }),
  imageIcon: (border: boolean, isImageIcon: boolean, color: string) => ({
    position: 'relative',
    width: isImageIcon ? 'auto' : 60,
    height: 60,
    borderRadius: isImageIcon ? 0 : '50%',
    border: border && !isImageIcon ? `1px solid ${color || theme.rawColors.neutralBlack}` : 'none',
    img: {
      objectFit: isImageIcon ? 'contain' : 'cover',
      borderRadius: isImageIcon ? 0 : '50%',
      width: isImageIcon ? 'auto !important' : border ? '58px !important' : '60px !important',
      height: border ? '58px !important' : '60px !important',
      position: isImageIcon ? 'static !important' : 'absolute'
    }
  }),
  hexIcon: (bg: string, border: boolean, color: string) => ({
    bg,
    width: 60,
    height: 60,
    borderRadius: '50%',
    border: border ? `1px solid ${color || theme.rawColors.neutralBlack}` : 'none'
  })
};